import React from "react";
import { Routes, Route } from "react-router-dom";

import AdminDashboardHome from "./AdminDashboardHome";
import AdminVoters from "./AdminDashVoters";
import AdminContactUs from "./AdminContactUs";

import AdminDevelopment from "./AdminDevelopment";
import AdminDevelopmentForm from "./AdminDevelopmentForm";

import AdminCMRFTable from "./AdminCMRFTable";
import AdminCmrFundsForm from "./AdminCmrFundsForm";

import AdminMp3Table from "./AdminMp3Table";
import AdminMp3Form from "./AdminMp3Form";

import AdminMp4Table from "./AdminMp4Table";
import AdminMp4Form from "./AdminMp4Form";

import AdminBeneficiariesTable from "./AdminBeneficiariesTable";
import AdminBeneficiariesForm from "./AdminBeneficiariesForm";
import AdminBeneficiaryLookup from "./AdminBeneficiaryLookup";

import AdminAdaBiddaNidhi from "./AdminAdaBiddaNidhi";
import AdminAdaBiddaNidhiForm from "./AdminAdaBiddaNidhiForm";

import AdminThallikiVandanamForm from "./AdminThallikiVandanamForm";
import AdminThallikiVandanamTable from "./AdminThallikiVandanamTable";

import AdminDeepamSchemeForm from "./AdminDeepamSchemeForm";
import AdminDeepamSchemeTable from "./AdminDeepamSchemeTable";

import AdminMahaShakthiForm from "./AdminMahaShakthiForm";
import AdminMahaShakthiTable from "./AdminMahaShakthiTable";

import AdminAnnadataSukhibhavaForm from "./AdminAnnadataSukhibhavaForm";
import AdminAnnadataSukhibhavaTable from "./AdminAnnadataSukhibhavaTable";

import AdminYuvagalamForm from "./AdminYuvagalamForm";
import AdminYuvagalamTable from "./AdminYuvagalamTable";

import AdminSurveyFeedbackForm from "./AdminSurveyFeedbackForm";
import AdminSurveyFeedbackTable from "./AdminSurveyFeedbackTable";

import AdminEventsTable from "./AdminEventsTable";
import AdminEventsForm from "./AdminEventsForm";

import AdminReportsPage from "./AdminReportsPage";

import AdminNotesFollowUpForm from "./AdminNotesFollowUpForm";
import AdminNotesFollowUpTable from "./AdminNotesFollowUpTable";

import AdminJanataDarbarTable from "./AdminJanataDarbarTable";
import AdminJanataDarbarForm from "./AdminJanataDarbarForm";

import AdminSettingsPage from "./AdminSettingsPage";
import AdminLocalLeadersTable from "./AdminLocalLeadersTable";
import AdminLocalLeadersForm from "./AdminLocalLeadersForm";
import AdminGalleryTable from "./AdminGalleryTable";
import AdminGalleryForm from "./AdminGalleryForm";
import AdminPressTable from "./AdminPressTable";
import AdminPressForm from "./AdminPressForm";
import AdminCommunicationDashboard from "./AdminCommunicationDashboard";
import AdminPollingBoothManagement from "./AdminPollingBoothManagement";
import AdminPoliticalSurveyWarRoom from "./AdminPoliticalSurveyWarRoom";

// ---------- DIAGNOSTIC: logs any import that resolved to undefined ----------
const routeComponents = {
  AdminDashboardHome,
  AdminVoters,
  AdminContactUs,
  AdminDevelopment,
  AdminDevelopmentForm,
  AdminCMRFTable,
  AdminCmrFundsForm,
  AdminMp3Table,
  AdminMp3Form,
  AdminMp4Table,
  AdminMp4Form,
  AdminBeneficiariesTable,
  AdminBeneficiariesForm,
  AdminBeneficiaryLookup,
  AdminAdaBiddaNidhi,
  AdminAdaBiddaNidhiForm,
  AdminThallikiVandanamForm,
  AdminThallikiVandanamTable,
  AdminDeepamSchemeForm,
  AdminDeepamSchemeTable,
  AdminMahaShakthiForm,
  AdminMahaShakthiTable,
  AdminAnnadataSukhibhavaForm,
  AdminAnnadataSukhibhavaTable,
  AdminYuvagalamForm,
  AdminYuvagalamTable,
  AdminSurveyFeedbackForm,
  AdminSurveyFeedbackTable,
  AdminEventsTable,
  AdminEventsForm,
  AdminReportsPage,
  AdminNotesFollowUpForm,
  AdminNotesFollowUpTable,
  AdminJanataDarbarTable,
  AdminJanataDarbarForm,
  AdminSettingsPage,
};

const brokenImports = Object.entries(routeComponents)
  .filter(([, comp]) => comp === undefined)
  .map(([name]) => name);

if (brokenImports.length > 0) {
  console.error(
    "❌ These imports are undefined (missing 'export default' or wrong path):",
    brokenImports
  );
}
// ---------- END DIAGNOSTIC ----------

function AdminDashboardRoutes() {
  return (
    <Routes>
      <Route path="/" element={<AdminDashboardHome />} />
      <Route path="/dashboard-home" element={<AdminDashboardHome/>} />
      <Route path="/voters" element={<AdminVoters />} />
      <Route path="/admincontact" element={<AdminContactUs />} />

      <Route path="/development" element={<AdminDevelopment />} />
      <Route path="/development-form" element={<AdminDevelopmentForm />} />

      <Route path="/cmrf-table" element={<AdminCMRFTable />} />
      <Route path="/cmrf-form" element={<AdminCmrFundsForm />} />

      <Route path="/mp3-table" element={<AdminMp3Table />} />
      <Route path="/mp3-form" element={<AdminMp3Form />} />

      <Route path="/mp4-table" element={<AdminMp4Table />} />
      <Route path="/mp4-form" element={<AdminMp4Form />} />

      <Route path="/beneficiaries-table" element={<AdminBeneficiariesTable />} />
      <Route path="/beneficiaries-form" element={<AdminBeneficiariesForm />} />
      <Route path="/BeneficiaryLookup" element={<AdminBeneficiaryLookup />} />

      <Route path="/AdaBiddaNidhi" element={<AdminAdaBiddaNidhi />} />
      <Route path="/AdaBiddaNidhiForm" element={<AdminAdaBiddaNidhiForm />} />

      <Route path="/ThallikiVandanamForm" element={<AdminThallikiVandanamForm />} />
      <Route path="/ThallikiVandanamTable" element={<AdminThallikiVandanamTable />} />

      <Route path="/DeepamSchemeForm" element={<AdminDeepamSchemeForm />} />
      <Route path="/DeepamSchemeTable" element={<AdminDeepamSchemeTable />} />

      <Route path="/MahaShakthiForm" element={<AdminMahaShakthiForm />} />
      <Route path="/MahaShakthiTable" element={<AdminMahaShakthiTable />} />

      <Route path="/AnnadataSukhibhavaForm" element={<AdminAnnadataSukhibhavaForm />} />
      <Route path="/AnnadataSukhibhavaTable" element={<AdminAnnadataSukhibhavaTable />} />

      <Route path="/YuvagalamForm" element={<AdminYuvagalamForm />} />
      <Route path="/YuvagalamTable" element={<AdminYuvagalamTable />} />

      <Route path="/SurveyFeedbackForm" element={<AdminSurveyFeedbackForm />} />
      <Route path="/SurveyFeedbackTable" element={<AdminSurveyFeedbackTable />} />

      <Route path="/EventsTable" element={<AdminEventsTable />} />
      <Route path="/EventsForm" element={<AdminEventsForm />} />

      <Route path="/ReportsPage" element={<AdminReportsPage />} />

      <Route path="/NotesFollowUpForm" element={<AdminNotesFollowUpForm />} />
      <Route path="/NotesFollowUpTable" element={<AdminNotesFollowUpTable />} />

      <Route path="/JanataDarbarTable" element={<AdminJanataDarbarTable />} />
      <Route path="/JanataDarbarForm" element={<AdminJanataDarbarForm />} />

      <Route path="/SettingsPage" element={<AdminSettingsPage />} />

      <Route path="/AdminLocalLeadersTable" element={<AdminLocalLeadersTable />} />
      <Route path="/AdminLocalLeadersForm" element={<AdminLocalLeadersForm />} />



      <Route path="/AdminGalleryTable" element={<AdminGalleryTable />} />
      <Route path="/AdminGalleryForm" element={<AdminGalleryForm />} />

      <Route path="/AdminPressTable" element={<AdminPressTable />} />
      <Route path="/AdminPressForm" element={<AdminPressForm />} />

        <Route path="/AdminCommunicationDashboard" element={<AdminCommunicationDashboard />} />

         <Route path="/AdminPollingBoothManagement" element={<AdminPollingBoothManagement />} />

         <Route path="/AdminPoliticalSurveyWarRoom" element={<AdminPoliticalSurveyWarRoom />} />

    </Routes>
  );
}

export default AdminDashboardRoutes;